module.exports = __webpack_public_path__ + "img/347-3e88a3.png";